import React from "react";
import { ClipboardCheck, BarChart3, FileText, BookOpen, Printer, ArrowDown } from "lucide-react";

const STAGES = [
  {
    icon: ClipboardCheck,
    label: "Visibility Check™",
    sub: "5-minute assessment",
    color: "#1488DC",
  },
  {
    icon: BarChart3,
    label: "Visibility Score™",
    sub: "Percentage-based",
    color: "#0F1F4D",
  },
  {
    icon: FileText,
    label: "Visibility Report™",
    sub: "Personalized findings",
    color: "#1488DC",
  },
  {
    icon: BookOpen,
    label: "School Visibility Playbook™",
    sub: "Practical strategies",
    color: "#0F1F4D",
  },
  {
    icon: Printer,
    label: "ED Tech Depot Solutions",
    sub: "The tools to act",
    color: "#1488DC",
  },
];

export default function VCFramework() {
  return (
    <section
      data-testid="vc-framework-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            The journey
          </div>
          <h2
            data-testid="vc-framework-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            From Insight to{" "}
            <span className="text-teal">Action.</span>
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            A clear five-stage path designed to help school leaders move from
            assessment to measurable improvement.
          </p>
        </div>

        <div className="cmyk-ribbon h-1 w-24 mb-12 rounded-full" aria-hidden />

        <div data-testid="vc-framework-flow" className="space-y-4">
          {STAGES.map((s, i) => {
            const Icon = s.icon;
            const isLast = i === STAGES.length - 1;
            return (
              <React.Fragment key={s.label}>
                <div
                  data-testid={`vc-framework-stage-${i}`}
                  className="group flex items-center gap-5 sm:gap-6 bg-[#F4F6F4] hover:bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-5 sm:p-6 transition-all hover:shadow-md hover:-translate-y-0.5"
                >
                  <span
                    className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center transition-transform group-hover:scale-110"
                    style={{ backgroundColor: s.color }}
                  >
                    <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" strokeWidth={2} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-serif text-lg sm:text-xl md:text-2xl font-bold text-navy leading-tight">
                      {s.label}
                    </h3>
                    <p className="text-sm text-slate-500 mt-0.5">{s.sub}</p>
                  </div>
                  <span className="hidden sm:inline-flex flex-shrink-0 text-[10px] uppercase tracking-[0.18em] font-bold text-teal">
                    Stage {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                {!isLast && (
                  <div className="flex justify-center" aria-hidden>
                    <ArrowDown className="w-5 h-5 text-teal" strokeWidth={2.5} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
